import { render, staticRenderFns } from "./PoliciesColumnSelect.vue?vue&type=template&id=1d650bdc&scoped=true"
import script from "./PoliciesColumnSelect.vue?vue&type=script&lang=ts"
export * from "./PoliciesColumnSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d650bdc",
  null
  
)

export default component.exports